import { formatDistanceToNow, parseISO, format } from 'date-fns'

export const formattedDate = dateString => {
  try {
    const parsedDate = parseISO(dateString)
    return format(parsedDate, 'MMMM do, yyyy')
  } catch {
    return dateString
  }
}

export const daysFromNow = dateString => {
  try {
    const parsedDate = parseISO(dateString)
    return formatDistanceToNow(parsedDate)
  } catch {
    return dateString
  }
}

export const isValidDate = dateObj => {
  if (dateObj instanceof Date && !isNaN(dateObj.valueOf())) {
    return true
  }
  return false
}
